import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { compose } from 'redux';
import { actions } from '../../redux/ProductReducer';
import { Form, Field, reduxForm, getFormValues } from 'redux-form';
import Button from '../../../../common/components/Button/Button';
import FieldFormControl from '../../../../common/components/FieldFormControl/FieldFormControl';
import { bySchemeType } from '../../helpers/formatSchemes';

const ActiveSchemes = ({ schemes, isSchemeGroup }) => {
  const schemesByType = useMemo(() => bySchemeType(schemes, isSchemeGroup), [
    schemes,
    isSchemeGroup,
  ]);
  const schemeTypes = Object.keys(schemesByType);

  return (
    <>
      {schemeTypes.map((schemeType) => {
        const schemeList = schemesByType[schemeType];
        return (
          <div className="activate-scheme-item-container">
            <h4 className={'capitalise'}> {schemeType} Schemes:</h4>
            {schemeList?.map((scheme) => {
              return (
                <div key={scheme.id}>
                  <Field
                    name={`schemes[${scheme.id}].export`}
                    type="checkbox"
                    value={scheme.id}
                    component={FieldFormControl}
                  >
                    <div className="activate-scheme-item">
                      <h4>
                        {scheme.attributes.name} - V{scheme.attributes.version}
                      </h4>
                    </div>
                  </Field>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

const SchemesExportForm = ({
  exportSchemes,
  productId,
  isSchemeGroup,
  schemes,
  handleSubmit,
  submitting,
  onComplete,
}) => {
  const doExport = (formValues) => {
    const formSchemes = formValues?.schemes ?? [];

    const schemesToExport = Object.keys(formSchemes).filter((schemeId) => {
      return formSchemes[schemeId].export;
    });

    const schemeKey = isSchemeGroup ? 'scheme_groups' : 'schemes';

    const values = {
      meta: {
        [schemeKey]: schemesToExport,
      },
    };

    return Promise.resolve(exportSchemes(productId, values, isSchemeGroup)).then(() => {
      onComplete();
    });
  };

  return (
    <Form onSubmit={handleSubmit(doExport)}>
      <Modal.Body>
        <h3>Select schemes to export:</h3>

        <ActiveSchemes schemes={schemes} isSchemeGroup={isSchemeGroup} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-blue"
          type={'submit'}
          isLoading={submitting}
          label="Export"
        />
      </Modal.Footer>
    </Form>
  );
};

const FORM_NAME = 'ExportSchemesForm';
export default compose(
  connect(
    (state, props) => {
      const schemeIds = props.schemes?.reduce((carry, scheme) => {
        carry[scheme.id] = {
          export: false,
        };
        return carry;
      }, {});

      return {
        formValues: getFormValues(FORM_NAME)(state),
        initialValues: {
          schemes: schemeIds,
        },
      };
    },
    {
      exportSchemes: actions.exportSchemes,
    },
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(SchemesExportForm);
